import './style.scss';

function App() {
  return (
    <div className="mc-vgrid">
      <div className="mc-vgrid__grid">
        <div className="line line-1"></div>
        <div className="line line-2"></div>
        <div className="line line-3"></div>          
        <div className="line line-4"></div>
        <div className="line line-5"></div>
      </div>
    </div> 
  );
}

export default App;


